import { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';

const IMPRINT_CONTENT = `Newgate AG
Alte Churerstrasse 47
9496 Balzers
Liechtenstein

Email: `;

const localPart = 'contact';
const domain = 'newgate.li';
const email = `${localPart}@${domain}`;

interface ImprintDialogProps {
    open: boolean;
    onClose: () => void;
}

export function ImprintDialog({ open, onClose }: ImprintDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundImage: 'none',
                },
            }}
        >
            <DialogTitle>Imprint</DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                    {IMPRINT_CONTENT} {email}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

export function useImprintDialog() {
    const [open, setOpen] = useState(false);
    return {
        imprintOpen: open,
        openImprint: () => setOpen(true),
        closeImprint: () => setOpen(false),
    };
}